module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'invoices',
        preventClearOnCancel: true,
    },

    methods: {
        async customSubmit(body, options){
            options = options || {}

            if(options.redo && ((body || {}).data || {}).attributes) {
                body.data.attributes.redoMissingStages = true
            }

            return this.performAction(this.prepareAction('submit', undefined, undefined, {
                source: {
                    submit: {
                        data: body
                    }
                }
            }))
        }
    }
}